import { render, staticRenderFns } from "./PasswordSetting.vue?vue&type=template&id=5ce4aa44"
import script from "./PasswordSetting.vue?vue&type=script&lang=ts"
export * from "./PasswordSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports